import { createStore, compose, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { fork, all } from 'redux-saga/effects';
import createReducer from './reducers';

// sagas
import authSagas from './containers/Auth/sagas';
import statisticsSagas from './containers/Statistics/sagas';
import settingsSagas from './containers/Settings/sagas';
import paymentInfoSagas from './containers/PaymentInfo/sagas';
import dashboardSagas from './pages/DashboardPage/sagas';

const debugMode = process.env.NODE_ENV !== 'production';

function startSagas(...sagas) {
  return function* rootSaga() {
    yield all(sagas.map(saga => fork(saga)));
  };
}

const loggerMiddleware = createLogger({
  collapsed: true,
});

const sagaMiddleware = createSagaMiddleware();

export function configureStore(history, initialState) {
  const middlewares = [sagaMiddleware, routerMiddleware(history)];

  let composeEnhancers = null;

  if (debugMode) {
    middlewares.push(loggerMiddleware);
    /* eslint-disable no-underscore-dangle */
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
    /* eslint-enable */
  }

  if (composeEnhancers === null) {
    composeEnhancers = compose;
  }

  const store = createStore(
    createReducer(),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );

  sagaMiddleware.run(
    startSagas(
      authSagas,
      statisticsSagas,
      settingsSagas,
      paymentInfoSagas,
      dashboardSagas,
    ),
  );

  return store;
}

/**
 * Sync history and store, as the react-router-redux reducer
 * is under the non-default key ("routing"), selectLocationState
 * must be provided for resolving how to retrieve the "route" in the state
 *
 * @return {any} The new state
 */
export const selectLocationState = () => {
  let prevRoutingState;
  let prevRoutingStateJS;

  return (state) => {
    const routingState = state.get('route');

    if (!routingState.equals(prevRoutingState)) {
      prevRoutingState = routingState;
      prevRoutingStateJS = routingState.toJS();
    }

    return prevRoutingStateJS;
  };
};



// WEBPACK FOOTER //
// ./src/store.js